import React, { FC } from 'react';
import { WysiwygEditor } from 'src/modules/shared/components';
import { useAppSelector } from 'src/modules/shared/hooks/useAppDispatch';
import EmptyContent from 'src/modules/shared/components/EmptyContent/EmptyContent';
import {
  NotificationsItemContainer,
  NotificationsItemDate,
  NotificationsItemLink,
  NotificationsItemTitle,
  NotificationsItemWrapper,
} from './styled';
import { NotificationsImage } from './image/NotificationsItemImage';
import {
  Notifications,
  useGetNotificationsQuery,
  useReadNotificationMutation,
} from 'src/modules/shared/slices/comunications/notifications/notificationsApi';
import { LogActionTypes, useDataLogging } from 'src/modules/shared/data-logging';
import { VideoPlayer } from 'src/modules/trajectory/components/TrajectoryDetail/blocks/VideoPlayer';

const options: Intl.DateTimeFormatOptions = {
  day: 'numeric',
  month: 'short',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
};

export const NotificationsItem: FC = () => {
  const log = useDataLogging();
  const selectedTab = useAppSelector((state) => state.notifications.selectedTab);
  const { data } = useGetNotificationsQuery(selectedTab === 0 ? true : false);
  const [readNotifications] = useReadNotificationMutation();

  const handleReadMessage = (item: Notifications, openNewTab?: boolean) => {
    log(LogActionTypes.NOTIFICATIONS_LINK_CLICK, { notificationId: item.id });
    if (selectedTab === 0) {
      readNotifications(item.id);
    }
    if (openNewTab) {
      window.open(item.link, '_blank');
    }
  };

  return (
    <NotificationsItemContainer>
      {data?.length === 0 && <EmptyContent message="Er zijn geen nieuwe berichten." />}
      {data?.map((item) => {
        return (
          <NotificationsItemWrapper key={item.id}>
            {item.media.type === 'image' && (
              <NotificationsImage
                alt={item.altTitle ?? item.title}
                src={item.media.url}
                onClick={() => handleReadMessage(item, true)}
              />
            )}
            {item.media.type === 'video' && (
              <VideoPlayer url={item.media.url} customStyle={{ aspectRatio: '16/9' }} hasLoading />
            )}
            <NotificationsItemTitle variant="h3">{item.title}</NotificationsItemTitle>
            <NotificationsItemDate variant="body2">
              {item.sentAt && Intl.DateTimeFormat('nl-BE', options).format(new Date(item.sentAt))}
            </NotificationsItemDate>
            <WysiwygEditor value={item.description || ''} readOnly id="notifications" />
            <NotificationsItemLink
              target="_blank"
              rel="no-referrer noreferrer"
              href={item.link}
              onClick={() => handleReadMessage(item)}
            >
              {item.linkDescription}
            </NotificationsItemLink>
          </NotificationsItemWrapper>
        );
      })}
    </NotificationsItemContainer>
  );
};
